import React from 'react';
import { useForm } from 'react-hook-form';

import Stack from '@mui/material/Stack';

import Form, { FormTextField, FormSelect } from '@ts-core/core/components/FormV2';

import { AddAcademyProfessorFormInput } from '../../types/form';
import { AcademyRole } from '../../types';

interface AddProfessorFormProps {
  onSubmit: (input: AddAcademyProfessorFormInput) => void;
  submitting?: boolean;
  submitError?: string;

  roles?: AcademyRole[];
}

const AddProfessorForm = (props: AddProfessorFormProps) => {
  const { roles = [], onSubmit, submitting = false, submitError } = props;

  const { handleSubmit, formState, control } = useForm<AddAcademyProfessorFormInput>();

  return (
    <Form sx={{ width: '100%' }} onSubmit={handleSubmit(onSubmit)} formState={formState} isSubmitting={submitting} submitError={submitError}>
      <Stack direction="column" spacing={2}>
        <FormTextField control={control} label="Nombre" name="name" fullWidth />
        <FormTextField control={control} label="Email" name="email" type="email" fullWidth />
        <FormTextField control={control} label="Contraseña" name="password" type="password" fullWidth />
        <FormTextField control={control} label="Repetir Contraseña" name="confirmPassword" type="password" fullWidth />
        <FormSelect control={control} label="Role" items={roles} name="role" itemTitleKey="name" itemValueKey="id" />
      </Stack>
    </Form>
  );
};

export default AddProfessorForm;
